import React, {useRef} from "react";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {setActiveObjDetails} from "../../../../slices/globalParamsSlice";
import {useOutsideClick} from "../../../../hooks/useOutsideClick";
import {useDateTimeParser} from "../../../../hooks/useDateTimeParser";

export const DetailsDialog = () => {
    const ref = useRef(null);
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const {activeObjDetails} = useSelector(state => state.globalParams.globalParams);
    const {parseDate, parseTime, timeZoneId} = useDateTimeParser();

    useOutsideClick([ref], () => dispatch(setActiveObjDetails(null)));

    const created = {
        date: parseDate(activeObjDetails?.created),
        time: parseTime(activeObjDetails?.created),
    };

    const updated = {
        date: parseDate(activeObjDetails?.updated),
        time: parseTime(activeObjDetails?.updated),
    };

    const clearDialogState = () => {
        dispatch(setActiveObjDetails(null));
    };

    if (!activeObjDetails) return null;

    return (
        <div className={'overlay'}>
            <div className={'form-dialog'} style={{padding: '1rem 2rem 2rem 2rem'}} ref={ref}>
                <div className={'context-menu-wrapper'}>
                    <div className={'context-menu-detail'}>
                        <div>{t('createdAt')}</div>
                        <div className={'context-menu-detail-value'}>{created.date}</div>
                    </div>
                    <div className={'context-menu-detail'}>
                        <div>{t('time')}</div>
                        <div className={'context-menu-detail-value'}>{created.time}</div>
                    </div>
                    <div className={'context-menu-detail'}>
                        <div>{t('by')}</div>
                        <div className={'context-menu-detail-value'}>{activeObjDetails?.createdBy ?? '-'}</div>
                    </div>

                    <div className={'draggable-position-separator'} style={{margin: '10px 0'}}/>

                    <div className={'context-menu-detail'}>
                        <div>{t('updatedAt')}</div>
                        <div className={'context-menu-detail-value'}>{updated.date}</div>
                    </div>
                    <div className={'context-menu-detail'}>
                        <div>{t('time')}</div>
                        <div className={'context-menu-detail-value'}>{updated.time}</div>
                    </div>
                    <div className={'context-menu-detail'}>
                        <div>{t('by')}</div>
                        <div className={'context-menu-detail-value'}>
                            {(updated.date && updated.date !== '-') ? activeObjDetails?.modifiedBy : '-'}
                        </div>
                    </div>
                </div>

                <div className={'decision-dialog-footer'} style={{padding: '0', alignItems: 'flex-start'}}>
                    <button onClick={clearDialogState} className={'general-button'}>
                        {t('close')}
                    </button>
                </div>
            </div>
        </div>
    );
};